import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'

const validationFormik = Yup.object({
  idProduto: Yup.number().required('Campo Obrigatório!'),
  idLoteProduto: Yup.number().required('Campo Obrigatório!'),
  idTipoMovimento: Yup.number().required('Campo Obrigatório!'),
  qtMovimento: Yup.number()
    .required('Campo Obrigatório!')
    .moreThan(0, 'A quantidade deve ser maior que zero'),
})

const retornaEquipamento = () => ({
  idProduto: undefined,
  adProduto: [],
  idLoteProduto: undefined,
  acLoteProduto: [],
  idTipoMovimento: undefined,
  acTipoMovimento: [],
  dsObservacao: undefined,
  qtMovimento: undefined,
})

const Edicao = ({ voltar }) => {
  const salva = async (values) => {
    const payload = {
      ...values,
    }

    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaEquipamento()}
      validationSchema={validationFormik}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, errors }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Produto"
                metodo="buscaProduto"
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acProduto}
                onChange={(_, v) => {
                  setFieldValue('idProduto', v?.[0]?.[0])
                  setFieldValue('acProduto', v)
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Lote do Produto"
                metodo="buscaLote"
                searchParams={{ idProduto: values.idProduto ?? -1 }}
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acLoteProduto}
                onChange={(_, v) => {
                  setFieldValue('idLoteProduto', v?.[0]?.[0])
                  setFieldValue('acLoteProduto', v)
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Tipo de Movimento"
                metodo="buscaTipoMovimento"
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acTipoMovimento}
                onChange={(_, v) => {
                  setFieldValue('idTipoMovimento', v?.[0]?.[0])
                  setFieldValue('acTipoMovimento', v)
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="qtMovimento"
                label="Quantidade"
                fullWidth
                type="number"
                margin="dense"
                variant="outlined"
                size="small"
                error={!!errors.qtMovimento}
                helperText={errors.qtMovimento?.message}
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsObservacao"
                label="Observações"
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
